import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=34b5ed9c&scoped=true&"
import script from "./TaskView.vue?vue&type=script&lang=js&"
export * from "./TaskView.vue?vue&type=script&lang=js&"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=34b5ed9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5ed9c",
  null
  
)

export default component.exports